
import isEmpty from 'lodash/isEmpty'

import { trackClick } from '@tracking/events'

import GradesModal from '../Modals/GradesModal'
import Picker from '../Picker'
import PickersList from '../PickersList'

import translations from './PickerGrade.translations'

export default {
  components: {
    GradesModal,
    Picker,
    PickersList,
  },

  props: {
    isCpo: {
      type: Boolean,
      default: false,
    },
    isAccessory: {
      type: Boolean,
      default: false,
    },
    grades: {
      type: Array,
      default: () => [],
    },
    clickOnLinkPicker: {
      type: Function,
      default: () => {},
    },
    selectedHighlightedPickers: {
      type: Object,
      default: null,
    },
  },

  computed: {
    translations: () => translations,

    displayGrades() {
      return !isEmpty(this.grades) && !this.isCpo && !this.isAccessory
    },

    isLegacyGrades() {
      return this.grades.length > 3
    },
  },

  methods: {
    gradeClick(grade) {
      if (!grade.isDisabled && !grade.selected) {
        trackClick({
          zone: 'grade_picker',
          name: grade.backboxGrade.value,
        })
      }
    },

    getPickerDescription({ isDisabled, price }) {
      return isDisabled ? this.$t(translations.soldOut) : this.$t.price(price)
    },

    getPickerTag(picker) {
      return picker.reassurance?.isGoodDeal
        ? this.$t(translations.goodDeal)
        : null
    },
  },
}
